import React from "react";
import { motion } from "framer-motion";
import houseImage from "../assets/house.jpeg";

const houses = [
  {
    name: "Oak House",
    color: "bg-red-500",
  },
  {
    name: "Pine House",
    color: "bg-green-500",
  },
  {
    name: "Cedar House",
    color: "bg-blue-500",
  },
  {
    name: "Maple House",
    color: "bg-yellow-500",
  },
];

const SchoolHouse = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">

        {/* ================= HEADING ================= */}
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="uppercase tracking-[6px] text-[#d4af37] font-bold mb-4">
            Cambridge International School
          </p>

          <h1 className="text-5xl md:text-6xl font-black text-[#07294d]">
            School Houses
          </h1>

          <div className="w-24 h-1 bg-[#d4af37] rounded-full mx-auto my-8"></div>
        </motion.div>

        {/* ================= SCHOOL HOUSES INTRO ================= */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="bg-[#f8fafc] border border-gray-100 rounded-[30px] shadow-lg p-10 mb-16"
        >
          <p className="text-lg text-gray-600 leading-9 mb-6">
            To foster the quality of leadership and to promote a spirit
            of healthy competition among the students, the school
            activities are organized on House basis.
          </p>

          <p className="text-lg text-gray-600 leading-9 mb-6">
            The school has been divided into four houses. The houses
            are named Oak, Pine, Cedar and Maple.
          </p>

          <p className="text-lg text-gray-600 leading-9">
            Each house has a Prefect and Vice Prefect who take
            inspiration and guidance from their House Mistress.
            They do their best to organize the competitions with
            a healthy spirit.
          </p>
        </motion.div>

        {/* ================= HOUSE CARDS ================= */}
        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8">
          {houses.map((house, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: index * 0.1,
              }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
              onClick={() => window.open(houseImage, "_blank")}
              className="bg-white border border-gray-100 rounded-[25px] shadow-lg p-5 text-center cursor-pointer group transition-shadow duration-300 hover:shadow-2xl"
            >
              {/* HOUSE IMAGE */}
              <div className="w-full h-52 rounded-[20px] overflow-hidden mb-6">
                <img
                  src={houseImage}
                  alt={house.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* HOUSE NAME */}
              <h3 className="text-3xl font-bold text-[#07294d]">
                {house.name}
              </h3>

              {/* COLOR LINE */}
              <div
                className={`w-16 h-1 ${house.color} rounded-full mx-auto mt-4`}
              ></div>

              <p className="text-gray-500 mt-4 text-sm">
                Click to view
              </p>
            </motion.div>
          ))}
        </div>

        {/* ================= SCHOOL BOOKLET ================= */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="mt-24"
        >
          {/* BOOKLET HEADING */}
          <div className="text-center mb-12">
            <p className="uppercase tracking-[6px] text-[#d4af37] font-bold mb-4">
              School Booklet
            </p>

            <h2 className="text-5xl font-black text-[#07294d]">
              Class : KG-II
            </h2>

            <div className="w-24 h-1 bg-[#d4af37] rounded-full mx-auto mt-6"></div>
          </div>

          {/* TABLE */}
          <div className="overflow-x-auto rounded-[25px] border border-gray-200 shadow-lg">
            <table className="w-full">
              <thead className="bg-[#07294d] text-white">
                <tr>
                  <th className="px-6 py-4 text-left">S.No.</th>
                  <th className="px-6 py-4 text-left">Subject</th>
                  <th className="px-6 py-4 text-center">Qty.</th>
                </tr>
              </thead>

              <tbody className="bg-white">

                <tr className="border-b">
                  <td className="px-6 py-4">1</td>
                  <td className="px-6 py-4">
                    Wings of Wonder - Madhuban
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b bg-gray-50">
                  <td className="px-6 py-4">2</td>
                  <td className="px-6 py-4">
                    Notebook - English 4 Line
                  </td>
                  <td className="px-6 py-4 text-center">4</td>
                </tr>

                <tr className="border-b">
                  <td className="px-6 py-4">3</td>
                  <td className="px-6 py-4">
                    Notebook - Math Square (Small Box)
                  </td>
                  <td className="px-6 py-4 text-center">4</td>
                </tr>

                <tr className="border-b bg-gray-50">
                  <td className="px-6 py-4">4</td>
                  <td className="px-6 py-4">
                    Notebook - Hindi (5 Line)
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b">
                  <td className="px-6 py-4">5</td>
                  <td className="px-6 py-4">
                    Notebook - Plain
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b bg-gray-50">
                  <td className="px-6 py-4">6</td>
                  <td className="px-6 py-4">
                    Star Sticker
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b">
                  <td className="px-6 py-4">7</td>
                  <td className="px-6 py-4">
                    Scale (Big)
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b bg-gray-50">
                  <td className="px-6 py-4">8</td>
                  <td className="px-6 py-4">
                    Clay (Set of 6 Shades)
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b">
                  <td className="px-6 py-4">9</td>
                  <td className="px-6 py-4">
                    Crayons (25 Shades)
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b bg-gray-50">
                  <td className="px-6 py-4">10</td>
                  <td className="px-6 py-4">
                    Child Safe Scissor
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b">
                  <td className="px-6 py-4">11</td>
                  <td className="px-6 py-4">
                    White Glue 100gms.
                  </td>
                  <td className="px-6 py-4 text-center">2</td>
                </tr>

                <tr className="border-b bg-gray-50">
                  <td className="px-6 py-4">12</td>
                  <td className="px-6 py-4">
                    Poster Colour (12 Shades)
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b">
                  <td className="px-6 py-4">13</td>
                  <td className="px-6 py-4">
                    Glue Stick
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b bg-gray-50">
                  <td className="px-6 py-4">14</td>
                  <td className="px-6 py-4">
                    Pencil Pkt.
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b">
                  <td className="px-6 py-4">15</td>
                  <td className="px-6 py-4">
                    Eraser (Pack of 20)
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b bg-gray-50">
                  <td className="px-6 py-4">16</td>
                  <td className="px-6 py-4">
                    Brush Flat No.6
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b">
                  <td className="px-6 py-4">17</td>
                  <td className="px-6 py-4">
                    Brush Round No.4 & 9
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b bg-gray-50">
                  <td className="px-6 py-4">18</td>
                  <td className="px-6 py-4">
                    Chart Paper (Assorted 5 Colours)
                  </td>
                  <td className="px-6 py-4 text-center">5</td>
                </tr>

                <tr className="border-b">
                  <td className="px-6 py-4">19</td>
                  <td className="px-6 py-4">
                    Floroscent Sheet (Assorted 4 Colours)
                  </td>
                  <td className="px-6 py-4 text-center">4</td>
                </tr>

                <tr className="border-b bg-gray-50">
                  <td className="px-6 py-4">20</td>
                  <td className="px-6 py-4">
                    Origami Sheet
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

                <tr className="border-b">
                  <td className="px-6 py-4">21</td>
                  <td className="px-6 py-4">
                    Glitter Sheet (Pack of 6)
                  </td>
                  <td className="px-6 py-4 text-center">6</td>
                </tr>

                <tr className="border-b bg-gray-50">
                  <td className="px-6 py-4">22</td>
                  <td className="px-6 py-4">
                    Sharpner
                  </td>
                  <td className="px-6 py-4 text-center">2</td>
                </tr>

                <tr>
                  <td className="px-6 py-4">23</td>
                  <td className="px-6 py-4">
                    Carry Bag
                  </td>
                  <td className="px-6 py-4 text-center">1</td>
                </tr>

              </tbody>
            </table>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default SchoolHouse;